export default __webpack_public_path__ + "images/small_deepecho_icon.9664816e68bf146ee2a657affcfefed5.png";